import React, { Component } from 'react';
import SystemSettings from './SystemSettings';
import {
  getSystemSettings,
  updateSystemSettings,
  getSystemSettingsConfig
} from './SystemSettings.actions';
import Store from '../../../../redux/Store';
import { showSnackbar } from '../../../../common/state/snackbar/Snackbar.actions';
import Constants from '../../../../common/constants/Constants';
import Validators from '../../../../common/utils/Validators';

class SystemSettingsContainer extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      config: []
    };
  }

  componentDidMount() {
    getSystemSettingsConfig()
      .then(res => {
        let configsObject = JSON.parse(res.body);
        this.setState({ config: configsObject.SystemSettings });
        return getSystemSettings();
      })
      .then(res => {
        this.setState({ data: res.body });
      });
  }

  _handleChangeFor = (propertyName, value, item, index) => {
    let newItem = {
      ...item,
      [propertyName]: value,
      hasChanges: true
    };
    let newData = this.state.data.slice(0);
    newData.splice(index, 1, newItem);

    let validationMessage = this._validateValue(propertyName, value, item);
    if (validationMessage !== '') {
      Store.dispatch(
        showSnackbar({
          type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
          message: validationMessage
        })
      );
    } else {
      this.setState({ data: newData });
    }
  };

  _validateValue = (propertyName, value, item) => {
    let validationMessage = '';

    if (propertyName === 'Value') {
      let config = this.state.config.find(conf => conf.Type == 'range' && conf.Key == item.Key);

      if (
        config != undefined &&
        value !== '' &&
        !Validators.validateIntegerNumberBetweenRange(value, +config.Min, +config.Max)
      ) {
        validationMessage = `Enter a value from the interval ${config.Min} - ${config.Max}`;
      }
    }

    return validationMessage;
  };

  _onClickSave = (item, index) => {
    updateSystemSettings(item.SystemSettingId, item)
      .then(res => {
        if (res.body) {
          let newData = this.state.data.slice(0);
          newData.splice(index, 1, res.body);
          this.setState({ data: newData });

          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
              message: 'Successfully updated setting.'
            })
          );
        } else {
          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
              message: 'Failed updating setting.'
            })
          );
        }
      })
      .catch(res => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed updating setting.'
          })
        );
      });
  };

  render() {
    return (
      <SystemSettings
        data={this.state.data}
        handleChangeFor={this._handleChangeFor}
        onClickSave={this._onClickSave}
        config={this.state.config}
      />
    );
  }
}

export default SystemSettingsContainer;
